import { render } from "./SubscriptionModal.vue?vue&type=template&id=116ac646&scoped=true"
import script from "./SubscriptionModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionModal.vue?vue&type=script&lang=js"

import "./SubscriptionModal.vue?vue&type=style&index=0&id=116ac646&scoped=true&lang=css"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116ac646"]])

export default __exports__